/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide1alt1Inputs */

const he_extension_slide1alt1 = /** @type {(inputs: Extension_Slide1alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוסף PriceDrop מציג היסטוריית מחירים עם גרפים מפורטים`)
};

const en_extension_slide1alt1 = /** @type {(inputs: Extension_Slide1alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PriceDrop extension showing price history with detailed charts`)
};

/**
* | output |
* | --- |
* | "PriceDrop extension showing price history with detailed charts" |
*
* @param {Extension_Slide1alt1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide1alt1 = /** @type {((inputs?: Extension_Slide1alt1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide1alt1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide1alt1(inputs)
	return en_extension_slide1alt1(inputs)
});
export { extension_slide1alt1 as "extension_slide1Alt" }